import { render, staticRenderFns } from "./AccountSystemModule.vue?vue&type=template&id=0ed244d0&"
import script from "./AccountSystemModule.vue?vue&type=script&lang=js&"
export * from "./AccountSystemModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports